import React from "react";
import { Box, Typography } from "@mui/material";

interface TwoFactorErrorAlertProps {
  error: string | null;
}

/**
 * Displays a styled error message for 2FA flows.
 * Renders nothing when error is null.
 */
const TwoFactorErrorAlert: React.FC<TwoFactorErrorAlertProps> = ({ error }) => {
  if (!error) return null;

  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        backgroundColor: "rgba(244, 67, 54, 0.1)",
        color: "#f44336",
        borderRadius: 2,
        textAlign: "center",
      }}
    >
      <Typography>{error}</Typography>
    </Box>
  );
};

export default TwoFactorErrorAlert;
